var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelihoistLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2079,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2228,
    y: 198,
    width: 2079,
    height: 2079
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2228 -198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2228,
    y: 198,
    width: 2079,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2637 1237.5C2637 889.284 2919.28 607 3267.5 607 3615.72 607 3898 889.284 3898 1237.5 3898 1585.72 3615.72 1868 3267.5 1868 2919.28 1868 2637 1585.72 2637 1237.5Z",
    fill: "#4472C4",
    fillRule: "evenodd",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2482,
    y: 452,
    width: 1571,
    height: 1571,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3065 1237.5C3065 1125.11 3155.44 1034 3267 1034 3378.56 1034 3469 1125.11 3469 1237.5 3469 1349.89 3378.56 1441 3267 1441 3155.44 1441 3065 1349.89 3065 1237.5Z",
    stroke: "#000000",
    strokeWidth: 48.125,
    strokeMiterlimit: 8,
    fill: "#81F248",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelihoistLight);
export default __webpack_public_path__ + "static/media/HelihoistLight.783504a5e60ea8e9a9659aded9d20f99.svg";
export { ForwardRef as ReactComponent };